import { useSelector } from "react-redux";

import { nodeDesignsStateSelector } from "@skilitics/nautilus-core-designer-data";

/**
 *
 * @deprecated Selectors should select a smaller portion of state.
 */
export const useNodeDesignsState = () => {
  return useSelector(nodeDesignsStateSelector);
};
